export default __webpack_public_path__ + "static/media/contactscreenhover.3d1e23fd.png";